import React from 'react';
import { Card } from 'react-bootstrap';

const FrontEndProjCart = ({FrontProject}) => {
  const {project_name,tech_used,live_site,proj_img,cliet_site,server_side}=FrontProject;

    return (
        <div>
              <Card style={{}} className='mx-auto card_style h-100 mb-4'>
                <Card.Img variant="top" src={proj_img} className="card_img"/>
                <Card.Body>
                    <Card.Title><span className='proj_name'>Project Name: </span><span className='dyna_proj'>{project_name}</span></Card.Title>
                    <Card.Text >
                      <h5><span className='tech_used'>Technology Used:</span></h5>  
                      <p className='font-weight-bold'>{tech_used}</p> 
                    </Card.Text>
                </Card.Body>
                 
                     <a href={live_site} target="_blank" className="text-warning font-weight-bold bg-dark p-3 btn_card">Live Website Link</a>
                 
                <Card.Body>
                <Card.Link><span className='font-weight-bold text-danger fs-5 fw-bold '>GitHub :</span><span className='mr-3 ml-2'><a href={cliet_site} target="_blank" className="bg-info p-2 text_color mx-2 rounded">Client Code</a></span></Card.Link>
                </Card.Body>
            </Card>
        </div>
    );
};

export default FrontEndProjCart;